import Login from '../components/Login'
import ForgetPassword from '../components/ForgetPassword'

import Auth from '../containers/Auth'

export default {
  path: '/',
  name: 'Auth',
  redirect: '/login',
  component: Auth,
  children: [{
    path: '/login',
    name: 'Login',
    component: Login,
    props: true
  }, {
    path: '/forgetPassword',
    name: 'ForgetPassword',
    component: ForgetPassword,
  }]
}



// WEBPACK FOOTER //
// ./src/Auth/route/index.js